import React from 'react';
import { Box, Typography, tooltipClasses } from '@mui/material';
import { PrimaryTooltip } from '../../../Components/StyledComponent';
import InfoIcon from '../../../Components/Icons/InfoIcon';

const YColumnsTooltip = () => {
    return (
        <PrimaryTooltip
            placement="bottom"
            sx={{
                [`& .${tooltipClasses.tooltip}`]: {
                    maxWidth: "400px",
                    textAlign: "left !important",
                }
            }}
            title={
                <Box sx={{fontSize: '14px', lineHeight: '18px', p: 1}}>
                    <Typography variant="fw400s12" component="div">
                        <span>Typing Convention:</span>
                        <br />
                        <div style={{ paddingLeft: '12px' }}>
                            <span>• Format: {'<entity_name>.<signal_name>'}</span><br />
                            <span>• Use lowercase for all text</span><br />
                            <div style={{ paddingLeft: '9px' }}>
                                <span>Example 1:</span><br />
                                <span style={{ fontWeight: 600 }}>batterysystem.voltage</span><br />
                                <span>Example 2:</span><br />
                                <span style={{ fontWeight: 600 }}>batterysystem.string1.accumulated_discharging_energy</span><br />
                            </div>
                            <br />
                            <span>1. Entity names:</span><br />
                            <div style={{ paddingLeft: '16px' }}>
                                <span>• Battery System → batterysystem</span><br />
                                <span>• {'Specific String → batterysystem.string<number>'}</span><br />
                                <span>• All Strings → batterysystem.stringall</span><br />
                            </div>
                            <br />
                            <span>2. Signal names:</span><br />
                            <div style={{ paddingLeft: '16px' }}>
                                <span>• Separate multiple words with "_"</span><br />
                                <span style={{ paddingLeft: '9px' }}>Example: <span style={{ fontWeight: 600 }}>accumulated_discharging_energy</span></span>
                            </div>
                        </div>
                    </Typography>
                </Box>
            }
        >
            <InfoIcon sx={{ width: 14, height: 14, "&:hover ": { color: "#4D44D8" }}} />
        </PrimaryTooltip>
    );
};

export default YColumnsTooltip;
